import { createSpinner } from './createSpinner';

export const setPreloader = dom => {
    const timer = setTimeout(() => {
        if (dom.querySelector('.spinner-loader')) return;
        const spinner = createSpinner();
        dom.appendChild(spinner);
    }, 200);
    return {
        destroy() {
            clearTimeout(timer);
            const spinner = dom.querySelector('.spinner-loader');
            if (spinner) {
                dom.removeChild(spinner);
            }
        },
    };
};
